import { module as modujs } from "modujs";
import { gsap } from "gsap";

export default class extends modujs {
	constructor(m) {
		super(m);

		this.links = [];
		this.medias = [];
		this.currentMedia = null;

		this.enter = this.enter.bind(this);
		this.leave = this.leave.bind(this);
	}

	init() {
		this.links = [...this.el.querySelectorAll("[data-menu-id]")];
		this.medias = [...this.el.querySelectorAll("[data-menu-media]")];

		this.medias.forEach((media, index) => {
			gsap.set(media, {
				yPercent: index === 0 ? 0 : 100,
				zIndex: index === 0 ? 1 : 0,
			});
		});

		this.currentMedia = this.medias[0] ?? null;

		this.links.forEach((link) => {
			link.addEventListener("mouseenter", this.enter);
		});

		this.el.addEventListener("mouseleave", this.leave);
	}

	enter(e) {
		const id = e.currentTarget.dataset.menuId;
		const targetMedia = this.el.querySelector(`[data-menu-media="${id}"]`);

		if (!targetMedia || targetMedia === this.currentMedia) return;

		const previous = this.currentMedia;

		gsap.set(targetMedia, {
			yPercent: 100,
			zIndex: 2,
		});

		gsap.to(targetMedia, {
			yPercent: 0,
			duration: 0.55,
			ease: "power3.out",
		});

		if (previous) {
			gsap.set(previous, { zIndex: 1 });
		}

		this.currentMedia = targetMedia;
	}

	leave() {
		this.medias.forEach((media) => {
			if (media !== this.currentMedia) {
				gsap.set(media, {
					yPercent: 100,
					zIndex: 0,
				});
			} else {
				gsap.set(media, { zIndex: 1 });
			}
		});
	}

	destroy() {
		this.links.forEach((link) => {
			link.removeEventListener("mouseenter", this.enter);
		});

		this.el.removeEventListener("mouseleave", this.leave);
	}
}